<div class="container pb-4 pt-4 ">
  <app-breadcrumb currentRouteName="Historique des demandes d'ajout d'utilisateur"
  [previousRoute]="{name: 'Gestion des utilisateurs', route: '/users'}"></app-breadcrumb>

  <h1 class="pt-4">Historique de mes demandes d'ajout d'utilisateur</h1>
  <button class="d-none d-md-inline-block  btn btn-outline-primary mt-2 mb-3" routerLink="/utilisateurs">
    <fa-icon icon="arrow-left" size="lg"></fa-icon>
    Retour
  </button>
  <div class="alert alert-info">
    <fa-icon icon="info-circle"></fa-icon>
    Retrouvez ici toutes les demandes d'ajout envoyées les 60 derniers jours.
  </div>

  @if(requests | async | requesttype:'ADD'; as userRequests) {
    @if(userRequests.length > 0) {
      <ls-dynamic-table [data]="userRequests" [headers]="tableHeaders" currentSort="date">
        <ng-template let-request>
          <td class="d-none d-md-table-cell">
            @if(request.accepted === null) {
              <fa-icon size="lg" ngbTooltip="En cours de traitement" class="text-info"
                [icon]="['far', 'clock']"/>
            } @else {
              @if(request.partial) {
                <fa-icon size="lg" (click)="viewReason(request)"
                  ngbTooltip="Accepté partiellement - voir la raison" class="text-warning cursor-pointer"
                  icon="check"/>
              } @else if(request.accepted) {
                <fa-icon size="lg" ngbTooltip="Accepté" class="text-success"
                  icon="check"/>
              } @else {
                <fa-icon size="lg" (click)="viewReason(request)" ngbTooltip="Rejeté - Voir la raison"
                  class="text-danger cursor-pointer" icon="times"/>
              }
            }
          </td>
          <th scope="row" class="d-table-cell d-md-none pt-0">
            {{ request.coords.firstname }} {{ request.coords.lastname }}
            <span class="float-end">
              @if(request.accepted === null) {
                <fa-icon size="lg" ngbTooltip="En cours de traitement" class="text-info"
                  [icon]="['far', 'clock']"/>
              } @else {
                @if(request.partial) {
                  <fa-icon size="lg" (click)="viewReason(request)"
                    ngbTooltip="Accepté partiellement - voir la raison" class="text-warning cursor-pointer"
                    icon="check"/>
                } @else if(request.accepted) {
                  <fa-icon size="lg" ngbTooltip="Accepté" class="text-success"
                    icon="check"/>
                } @else {
                  <fa-icon size="lg" (click)="viewReason(request)" ngbTooltip="Rejeté - Voir la raison"
                    class="text-danger cursor-pointer" icon="times"/>
                }
              }
            </span>
          </th>
          <td>{{ request.date | date:'dd MMMM y à HH:mm' }}</td>
          <td class="d-none d-md-table-cell">{{ request.coords.lastname }}</td>
          <td class="d-none d-md-table-cell">{{ request.coords.firstname }}</td>
          <td>{{ request.coords.email }}</td>
          <td>
            <span class="d-block d-md-none">
              Logiciel(s) :
            </span>
            <!--suppress TypeScriptValidateTypes -->
            @for (item of request.products | keyvalue; track item) {
              <span class="product d-block d-md-inline-block">
                @if(getCategoryFromSlug(item.key); as cat) {
                  <app-badge class="me-1 ms-1"
                    [label]="{id: 0, textcolor: cat.textcolor, backcolor: cat.backcolor, name: cat.name}"/>
                }
              </span>
            }
          </td>
        </ng-template>
      </ls-dynamic-table>
    } @else {
      <p class="text-light-grey">Aucune demande d'ajout en attente</p>
    }
  } @else {
    <ls-spinner/>
  }

  <app-dynamic-modal-form title="Raison du rejet de la demande" [object]="toView">
    <ng-template>
      <p style="white-space: pre-line">{{ toView.rejectReason }}</p>
    </ng-template>
  </app-dynamic-modal-form>
</div>
